export const availableCountries = [
  // North America & Caribbean
  'ag', // Antigua and Barbuda (+1268)
  'bs', // Bahamas (+1242)
  'bb', // Barbados (+1246)
  'bm', // Bermuda (+1441)
  'ca', // Canada (+1)
  'ky', // Cayman Islands (+1345)
  'do', // Dominican Republic (+1809)
  'jm', // Jamaica (+1876, +1658)
  'mx', // Mexico (+52)
  'pr', // Puerto Rico (+1787)
  'lc', // St Lucia (+1758)
  'tt', // Trinidad and Tobago (+1868)
  'tc', // Turks and Caicos Islands (+1649)
  'us', // United States (+1)
  'vg', // Virgin Islands, British (+1284)
  'vi', // Virgin Islands, U.S. (+1340)

  // Asia / Middle East
  'af', // Afghanistan (+93)
  'cn', // China (+86)
  'hk', // Hong Kong (+852)
  'in', // India (+91)
  'jp', // Japan (+81)
  'kr', // Korea Republic of (+82)
  'pk', // Pakistan (+92) – High Risk
  'ph', // Philippines (+63)
  'ru', // Russia/Kazakhstan (+7)
  'kz', // Russia/Kazakhstan (+7)
  'sa', // Saudi Arabia (+966)
  'sg', // Singapore (+65)
  'tr', // Turkiye (+90)
  'ae', // United Arab Emirates (+971)

  // Europe
  'at', // Austria (+43)
  'be', // Belgium (+32)
  'cz', // Czech Republic (+420)
  'dk', // Denmark (+45)
  'fi', // Finland/Aland Islands (+358)
  'ax', // Finland/Aland Islands (+358)
  'fr', // France (+33)
  'de', // Germany (+49)
  'gr', // Greece (+30)
  'gg', // Guernsey/Jersey (+44)
  'je', // Guernsey/Jersey (+44)
  'ie', // Ireland (+353)
  'im', // Isle of Man (+44)
  'it', // Italy (+39)
  'xk', // Kosovo (+383)
  'lu', // Luxembourg (+352)
  'mt', // Malta (+356)
  'mc', // Monaco (+377)
  'nl', // Netherlands (+31)
  'no', // Norway (+47)
  'pl', // Poland (+48)
  'pt', // Portugal (+351)
  'mk', // Republic of North Macedonia (+389)
  'ro', // Romania (+40)
  'rs', // Serbia (+381)
  'es', // Spain (+34)
  'se', // Sweden (+46)
  'ch', // Switzerland (+41)
  'nc', // Turkish Republic of Northern Cyprus (+90)
  'ua', // Ukraine (+380)
  'gb', // United Kingdom (+44)

  // South America
  'br', // Brazil (+55)
  'cl', // Chile (+56)
  'co', // Colombia (+57)
  'py', // Paraguay (+595)
  'pe', // Peru (+51)

  // Africa
  'cm', // Cameroon (+237)
  'eg', // Egypt (+20)
  'et', // Ethiopia (+251)
  'lr', // Liberia (+231)
  'ma', // Morocco/Western Sahara (+212)
  'eh', // Morocco/Western Sahara (+212)
  'na', // Namibia (+264)
  'so', // Somalia (+252)
  'za', // South Africa (+27)

  // Oceania
  'as', // American Samoa (+1684)
  'au', // Australia/Cocos/Christmas Island (+61)
  'cc', // Australia/Cocos/Christmas Island (+61)
  'cx', // Australia/Cocos/Christmas Island (+61)
  'gu', // Guam (+1671)
  'nz', // New Zealand (+64)
  'mp', // Northern Mariana Islands (+1670)
  'vu', // Vanuatu (+678)
];

export const availableCountriesMap = Object.fromEntries(
  availableCountries.map((code) => [code, true]),
);
